// src/App.tsx
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import { AuthProvider } from './contexts/AuthContext';
import { IssueProvider } from './contexts/IssueContext';
import { IssuesCacheProvider } from './contexts/IssuesCacheContext';
import { UniqueUserIdProvider } from './contexts/UniqueUserIdContext';
import { LoginSuccessHandler } from './components/auth/LoginSuccessHandler';
import { NotificationProvider } from './contexts/NotificationContext';
import Notification from './components/common/Notification';
import { CustomerProvider } from './contexts/CustomerContext';
import './App.css';

function App() {

  return (
    <Router>
      {/* Wrap with the UniqueUserIdProvider */}
      <UniqueUserIdProvider>
        <NotificationProvider> 
          <AuthProvider>
          <CustomerProvider>
            <LoginSuccessHandler/>
            <IssueProvider>
              <IssuesCacheProvider>
                <AppRoutes />
                <Notification />
              </IssuesCacheProvider>
            </IssueProvider>
            </CustomerProvider>
          </AuthProvider>
        </NotificationProvider> 
      </UniqueUserIdProvider>
    </Router>
  );
}

export default App;
